module.exports = __webpack_public_path__ + "media/images/eedn-image-d2a6f62179b3d6b24278377897a5112b.png";